import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export interface RemoveCommonDocumentTypeRequest {
    engagementId: number;
    name: string;
}

export const RemoveCommonDocumentType = createAsyncThunk(
    'transactionDocuments/removeCommonDocumentType',
    async (params: RemoveCommonDocumentTypeRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/CommonDocumentTypes`,
                { params: { name: params.name } }
            );

            if (response.status !== 200) {
                throw new Error('Failed to remove the common document type');
            }

            return response.data as TransactionDocuments;
        } catch (error) {
            createNotification('Could not remove the common document type.', 'error');
            throw error;
        }
    }
);
